import { Type } from "@sinclair/typebox";

//#region src/shared/datasources.ts
/**
* For now, defineDatasources() force the usage of a custom (internal) datasource
* @returns
*/
function defineDatasource(datasource) {
	return {
		...datasource,
		provider: "internal",
		schema: mapDatasourceSchemaWithInternalProperties(datasource.schema)
	};
}
const datasourceSystemProperties = Type.Object({
	$id: Type.Optional(Type.String({
		title: "Id",
		format: "text"
	})),
	$publicationDate: Type.Optional(Type.String({
		title: "Publication Date",
		format: "date-time"
	})),
	$slug: Type.Optional(Type.String({
		title: "Slug",
		format: "slug"
	})),
	$lastModificationDate: Type.Optional(Type.String({
		title: "Last Modification",
		format: "date-time"
	}))
});
/**
* Map a datasource schema to include $id, $createdAt, and $updatedAt properties.
*/
function mapDatasourceSchemaWithInternalProperties(schema) {
	const { items,...rest } = schema;
	return {
		...rest,
		items: {
			...items,
			type: "object",
			properties: {
				...items.properties,
				...datasourceSystemProperties.properties
			},
			required: Array.from(new Set([
				"$id",
				"$slug",
				"$lastModificationDate",
				...items.required
			]))
		}
	};
}
/**
* Extract the indexed fields of a datasource with their titles
*/
function getDatasourceIndexedFieldsWithTitles(datasource) {
	if ("indexes" in datasource === false) {
		console.error("no datasource or indexes found", datasource);
		return [];
	}
	const properties = datasource.schema?.items?.properties || {};
	return Array.from(new Set(datasource.indexes?.map((idx) => idx.fields[0]) ?? [])).map((field) => ({
		value: field,
		title: properties[field]?.title || field
	}));
}

//#endregion
export { datasourceSystemProperties, defineDatasource, getDatasourceIndexedFieldsWithTitles, mapDatasourceSchemaWithInternalProperties };
//# sourceMappingURL=datasources.js.map